Apt.fn.extend('maps', {
	/**
	 * Get map style
	 */
	getStyle() {
		return LS.store.get('style') || 'dynamic';
	},

	/**
	 * Set map style
	 *
	 * @param {String} [style]
	 * @param {Boolean} [store=false]
	 * @param {Function} [fn]
	 */
	setStyle(style, store, fn) {
		const scope = this;
		const priv = scope.$private;
		const map = priv.map;

		priv.model.$set('style', style);

		if (store) {
			LS.store.set('style', style);
		}

		if (priv.conf.style === style) {
			return;
		}

		priv.conf.style = style;

		scope.bind('map', 'style.load', () => {
			scope.ready(() => {
				for (const [id, source] of Object.entries(priv.instance.sources)) {
					if (! priv.map.getSource(id)) {
						map.addSource(id, source);
					}
				}

				if (priv.model.$get('terrain')) {
					priv.setPitch(true);
				}

				priv.addMarkerImage(() => {
					for (const [id, layer] of Object.entries(priv.instance.layers)) {
						if (! priv.map.getLayer(id)) {
							map.addLayer(layer[0], layer[1]);
						}
					}

					priv.addMarkers();
					priv.updateGroupDensity();
				});

				const highlighted = scope.highlighted;

				if (highlighted) {
					scope.highlighted = null;

					scope.highlight(highlighted);
				}

				if (fn) {
					fn();
				}
			});
		}, true);

		scope.ready(() => {
			map.setStyle(priv.getStyling(style), {
				diff: false // Workaround for issue reapplying previously loaded style
			});
		});
	}
}, {
	/**
	 * Initialize style layers
	 */
	initStyle() {
		const scope = this;
		const pub = scope.$public;

		scope.model.$set('layers', {
			active: [],
			bases: scope.bases,
			overlays: scope.overlays
		});

		$.events.on({
			'$mapLayer': {
				change: (e, el) => {
					scope.toggleLayer(el, el.checked);
				}
			},
			'$mapStyle': {
				change: (e, el) => {
					scope.removeOptions();

					pub.setStyle(el.value, true);

					LS.analytics.interact('map', 'style', el.value);
				}
			}
		}, {
			delegate: scope.$overlay,
			namespace: scope.uid
		});
	},

	/**
	 * Toggle layer
	 *
	 * @param {$} el
	 * @param {Boolean} [enable=false]
	 */
	toggleLayer(el, enable) {
		const scope = this;
		const key = el.value;
		const type = el.name;

		if (enable) {
			if (type === 'base') {
				if (scope.base) {
					scope.toggleLayer(scope.base);
				}

				scope.base = el;
			}

			scope.addTiles(type, key);

			LS.analytics.interact('map', 'layer', key);

			return;
		}

		if (type === 'base' && scope.base === el) {
			scope.base = null;
		}

		scope.model.$drop('layers.active', key);

		scope.removeLayer(key);
		scope.removeSource(key);
	},

	/**
	 * Get active style data
	 *
	 * @param {String} [style='dynamic']
	 * @returns {String}
	 */
	getStyling(style = 'dynamic') {
		return `/assets/modules/maps@${$.get('versions.maps')}/data/${style}.json`;
	},

	/**
	 * Add tiles
	 *
	 * @param {String} type
	 * @param {String} key
	 */
	addTiles(type, key) {
		const scope = this;
		const options = scope[type + 's'][key];

		scope.model.$push('layers.active', key);

		if (scope.map.getLayer(key)) {
			return;
		}

		scope.$public.ready(() => {
			let source = options.source;

			if (options.tiles) {
				source = {
					type: 'raster',
					tileSize: 512,
					tiles: [
						options.tiles
					]
				};
			}

			if (options.maxzoom) {
				source.maxzoom = options.maxzoom;
			}

			if (options.minzoom) {
				source.minzoom = options.minzoom;
			}

			scope.addSource(key, source);

			const layer = options.layer || {
				id: key,
				type: 'raster',
				source: key
			};

			if (options.opacity) {
				layer.paint = {
					'raster-opacity': options.opacity
				};
			}

			 scope.addLayer(layer, options.before || 'contours');
		});
	}
});